import { Select, SelectProps } from '@chakra-ui/react';

const defaultStyles: SelectProps = {
    backgroundColor: 'white',
};

type DrawerSelectProps = SelectProps & {
    /** When value is empty, show placeholder-style (grey) color */
    value?: string;
};

export function DrawerSelect({ value = '', ...props }: DrawerSelectProps) {
    return (
        <Select
            {...defaultStyles}
            color={value === '' ? 'grey' : 'black'}
            value={value}
            {...props}
        />
    );
}
